export default __webpack_public_path__ + "static/media/dashboard-doctor-img.f444c34d.png";